import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    _hsq?: any[];
  }
}

export default function HubSpotPageView() {
  const location = useLocation();

  useEffect(() => {
    if (window._hsq) {
      const path = location.pathname + location.search;
      window._hsq.push(["setPath", path]);
      window._hsq.push(["trackPageView"]);
    }
  }, [location.pathname, location.search]);

  return null;
}
